import { createFileRoute } from '@tanstack/react-router'

import { ShipmentEventsPage } from '#/modules/activity/events-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/shipment-events')({
  component: ShipmentEventsPage,
  validateSearch: validateListSearch,
})
